import { Injectable } from '@angular/core';
import { HelpersService } from '../helpers/helpers.service';
import * as is from 'is_js';
import { Observable } from 'rxjs/Observable';
import { Router } from '@angular/router';
import { Subject } from 'rxjs/Subject';
import { AuthKey } from '../../data/auth-key.enum';
import { ResponseObj, AuthenticationService, AuthenticationInput } from '../../data/a2srv-client-api';
import { CustomerServicesService, SubscriberServicesService } from '../../data/crm-client-api';
import { ContentP, ProductP, CustomerP, ClientServicesService, RegistrationInput } from '../../data/360-client-api';

@Injectable()

export class AuthService {

  private refreshHeader = new Subject<boolean>();
  private isLogout = new Subject<boolean>();

  refreshHeader$ = this.refreshHeader.asObservable();
  isLogout$ = this.isLogout.asObservable();

  private returnUrl: string;
  public anonToken: string;

  constructor(private helpers: HelpersService,
    private restAuth: AuthenticationService,
    private restCustomer: CustomerServicesService,
    private restSubs: SubscriberServicesService,
    private restClient: ClientServicesService,
    private router: Router,
  ) {
  }

  refreshHead(data: boolean) {
    this.refreshHeader.next(data);
  }

  // islogout(data: boolean) {
  //   this.isLogout.next(data);
  // }

  isAuthenticated(isRedirectToLogin: boolean = false, returnUrl: string = '/') {
    // const status = is.existy(localStorage.getItem(AuthKey.LOGIN_KEY));
    // if (!status && isRedirectToLogin) {
    //   // redirect to login page with the return url
    //   this.returnUrl = returnUrl;
    //   this.router.navigate(['/user/login']);
    // }
    // return status;
    // if (localStorage.getItem(AuthKey.ANON_TOKEN)) {
    //   return true;
    // }
    // else {
    //   return false
    // }
    return true;
   
  }

  getAnonToken() {
    return this.restAuth.anonClient().map(response => {
      if (is.existy(response) && response.code == 200) {
        this.anonToken = response.data;
        return response;
      }
      else if (response.code == 900){
        this.router.navigateByUrl("/geo-blocked")
        return response;
      }
      else {
        return response;
      }
    })
  }

  getUserContents(): Array<ContentP> {
    const contentsData = JSON.parse((localStorage.getItem(AuthKey.VOD_KEY) || null));
    if (is.existy(contentsData)) {
      return contentsData;
    }
    return [];
  }

  getUserChannels(): Array<any> {
    const loginData = JSON.parse((localStorage.getItem(AuthKey.CURRENT_USER_KEY) || null));
    if (is.existy(loginData)) {
      return loginData.channels;
    }
    return [];
  }

  navigateToDefault() {
    this.router.navigate([this.returnUrl || '/']);
    this.returnUrl = null;
  }

}



// WEBPACK FOOTER //
// /var/lib/jenkins/workspace/sportstv/client/sportstv-web-client-prod/src/app/core/authentication/auth.service.ts